import { useRecipeStore } from '@/stores/recipeStore.js'
import { computed, onMounted } from 'vue'
import { DateTime } from 'luxon'

export default {
  name: 'Recipe',

  setup() {
    const recipeStore = useRecipeStore()
    const recipes = computed(() => recipeStore.recipes)

    const headers = [
      { title: 'Rezept Titel', key: 'title' },
      { title: 'Anzahl Zutaten', key: 'ingredients' },
      { title: 'Zuletzt geändert', key: 'updatedAt' },
      { title: 'Aktionen', key: 'actions' },
    ]

    onMounted(async () => {
      await recipeStore.fetchRecipes()
    })

    function getNiceDate(date) {
      if (!date) return ''
      const dt = DateTime.fromJSDate(new Date(date))
      return dt.toFormat('dd.MM.yyyy HH:mm')
    }

    function goToPage(path) {
      window.location.href = path
    }

    function editRecipe(item) {
      window.location.href = `/recipes-edit/${item._id}`
    }

    async function deleteRecipe(item) {
      await recipeStore.removeRecipe(item._id)
    }

    return { recipes, headers, getNiceDate, goToPage, editRecipe, deleteRecipe }
  },
}
